/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ApplySpaceTemplate,
  ChangeRequest,
  ChangeRequestOrderBy,
  ChangeRequestStatus,
  ChangeRequestSubject,
  JSONDocument,
  List,
  URL,
} from "./data-contracts";

/**
 * No description
 * @tags change-requests
 * @name CreateChangeRequest
 * @summary Create a change request
 * @request POST:/spaces/{spaceId}/change-requests
 * @secure
 */

// @ts-ignore
export const createChangeRequest: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Subject of the change-request */
    subject?: string;
    /** Template to apply to the change request */
    template?: ApplySpaceTemplate;
    [key: string]: any;
  };
  RequestHeaders: {};
  ResponseBody: ChangeRequest;
  ResponseStatusCode: 201;
} = {
  route: "/spaces/{spaceId}/change-requests",
  method: "post",
  streaming: false,
  tags: ["change-requests"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-requests
 * @name ListChangeRequestsForSpace
 * @summary List all change requests
 * @request GET:/spaces/{spaceId}/change-requests
 * @secure
 */

// @ts-ignore
export const listChangeRequestsForSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If defined, only change requests matching this status will be returned.
     * @default "open"
     */
    status?: ChangeRequestStatus;
    /** If defined, only change requests created by this user will be returned. */
    creator?: string;
    /** If defined, only change requests with contributions from this user will be returned. */
    contributor?: string;
    /** If defined, only change requests with a requested reviewer for this user will be returned. */
    requestedReviewer?: string;
    /** If defined, only change requests associated with this conversations issues cluster will be returned. */
    conversationsIssuesCluster?: string;
    /** The field to sort change requests by. Defaults to 'updatedAt'. */
    orderBy?: ChangeRequestOrderBy;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ChangeRequest[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests",
  method: "get",
  streaming: false,
  tags: ["change-requests"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-requests
 * @name GetChangeRequestById
 * @summary Get a change request by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}
 * @secure
 */

// @ts-ignore
export const getChangeRequestById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ChangeRequest;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}",
  method: "get",
  streaming: false,
  tags: ["change-requests"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-requests
 * @name UpdateChangeRequestById
 * @summary Update a change request
 * @request PATCH:/spaces/{spaceId}/change-requests/{changeRequestId}
 * @secure
 */

// @ts-ignore
export const updateChangeRequestById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Subject of the change request */
    subject?: ChangeRequestSubject;
    description?: JSONDocument;
    status?: "draft" | "open" | "archived";
  };
  RequestHeaders: {};
  ResponseBody: ChangeRequest;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}",
  method: "patch",
  streaming: false,
  tags: ["change-requests"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-requests
 * @name MergeChangeRequest
 * @summary Merge a change request
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/merge
 * @secure
 */

// @ts-ignore
export const mergeChangeRequest: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** ID of the resulting revision */
    revision: string;
    result: "merge" | "conflicts";
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/merge",
  method: "post",
  streaming: false,
  tags: ["change-requests"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-requests
 * @name UpdateChangeRequest
 * @summary Pull primary content into the change request
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/update
 * @secure
 */

// @ts-ignore
export const updateChangeRequest: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** ID of the resulting revision */
    revision: string;
    result: "update" | "conflicts";
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/update",
  method: "post",
  streaming: false,
  tags: ["change-requests"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-requests
 * @name GetChangeRequestPdf
 * @summary Get a URL of the content of a change request as PDF
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/pdf
 * @secure
 */

// @ts-ignore
export const getChangeRequestPDF: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /** Generate a PDF only for the provided page. */
    only?: boolean;
    /** ID of a specific page to generate a PDF for. */
    page?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Temporary URL to print the content. The URL will work for 1h. */
    url: URL;
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/pdf",
  method: "get",
  streaming: false,
  tags: ["change-requests"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-requests
 * @name ListChangeRequestsForOrganization
 * @summary List all change requests in an organization
 * @request GET:/orgs/{organizationId}/change-requests
 * @secure
 */

// @ts-ignore
export const listChangeRequestsForOrganization: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If defined, only change requests matching the statuses will be returned.
     * @default ["open"]
     */
    status?: ChangeRequestStatus[];
    /** If defined, only change requests created by this user will be returned. */
    creator?: string;
    /** If defined, only change requests with contributions from this user will be returned. */
    contributor?: string;
    /** If defined, only change requests with a requested reviewer for this user will be returned. */
    requestedReviewer?: string;
    /** If defined, only change requests associated with this conversations issues cluster will be returned. */
    conversationsIssuesCluster?: string;
    /** The field to sort change requests by. Defaults to 'updatedAt'. */
    orderBy?: ChangeRequestOrderBy;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ChangeRequest[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/change-requests",
  method: "get",
  streaming: false,
  tags: ["change-requests"],
  criticalityLevel: "low",
  deprecated: false,
};
